import React from 'react'
import {
    Typography,
    Grid, 
    Link
} from "@material-ui/core";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { makeStyles, useTheme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    container: {
        padding:'0px 30px',
        marginBottom:theme.spacing(6), 
    },
    gridItem: {
        width: '8rem',
        textAlign: 'center',
        marginTop: '16px!important',
        [theme.breakpoints.only('sm')]: {
            width: '17rem',
        },
        [theme.breakpoints.up('lg')]: {
            width: '11rem',
        }
    },
    gridItemTitle: {
        textAlign:'center', 
        marginBottom:'10px', 
        width:'9rem', 
        color: theme.palette.grey.darkest, 
        fontWeight:600
    },
    gridItemIcon: {
        textAlign:'center', 
        marginBottom:'10px'
    },
    typography: {
        display:'grid', 
        gridTemplateColumns:'90% 10%!important', 
        alignItems:'center',
            [theme.breakpoints.up('sm')]: { 
                display:'flex', 
                justifyContent:'center', 
                alignItems:'center'
        }
    }
}))


const WaysToReceive = ({content}) => {
    const classes = useStyles()
    const theme = useTheme();

    const CardIcon = () => {

        return (
            <svg width="58" height="44" viewBox="0 0 58 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.0605 32.9375C10.0605 32.0781 10.7707 31.375 11.6388 31.375H17.9519C18.82 31.375 19.5302 32.0781 19.5302 32.9375C19.5302 33.7969 18.82 34.5 17.9519 34.5H11.6388C10.7707 34.5 10.0605 33.7969 10.0605 32.9375ZM22.6868 32.9375C22.6868 32.0781 23.397 31.375 24.2651 31.375H36.8913C37.7594 31.375 38.4696 32.0781 38.4696 32.9375C38.4696 33.7969 37.7594 34.5 36.8913 34.5H24.2651C23.397 34.5 22.6868 33.7969 22.6868 32.9375ZM0.59082 6.375C0.59082 2.92285 3.41693 0.125 6.90395 0.125H51.0959C54.578 0.125 57.409 2.92285 57.409 6.375V37.625C57.409 41.0723 54.578 43.875 51.0959 43.875H6.90395C3.41693 43.875 0.59082 41.0723 0.59082 37.625V6.375ZM3.74739 6.375V9.5H54.2524V6.375C54.2524 4.64941 52.8418 3.25 51.0959 3.25H6.90395C5.16094 3.25 3.74739 4.64941 3.74739 6.375ZM3.74739 18.875H54.2524V12.625H3.74739V18.875ZM3.74739 22V37.625C3.74739 39.3535 5.16094 40.75 6.90395 40.75H51.0959C52.8418 40.75 54.2524 39.3535 54.2524 37.625V22H3.74739Z" fill="#272E35"/>
            </svg>
        )
    }

    const BarCodeIcon = () => {

        return (
            <svg width="58" height="50" viewBox="0 0 58 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.5625 3.125C4.69922 3.125 4 3.82422 4 4.6875V14.0625C4 14.9219 3.30078 15.625 2.4375 15.625C1.57461 15.625 0.875 14.9219 0.875 14.0625V4.6875C0.875 2.09863 2.97363 0 5.5625 0H14.9375C15.7969 0 16.5 0.699609 16.5 1.5625C16.5 2.42578 15.7969 3.125 14.9375 3.125H5.5625ZM16.5 14.0625V35.9375C16.5 36.7969 15.7969 37.5 14.9375 37.5C14.0781 37.5 13.375 36.7969 13.375 35.9375V14.0625C13.375 13.2031 14.0781 12.5 14.9375 12.5C15.7969 12.5 16.5 13.2031 16.5 14.0625ZM19.625 14.0625C19.625 13.2031 20.3281 12.5 21.1875 12.5C22.0469 12.5 22.75 13.2031 22.75 14.0625V35.9375C22.75 36.7969 22.0469 37.5 21.1875 37.5C20.3281 37.5 19.625 36.7969 19.625 35.9375V14.0625ZM41.5 14.0625C41.5 13.2031 42.2031 12.5 43.0625 12.5C43.9219 12.5 44.625 13.2031 44.625 14.0625V35.9375C44.625 36.7969 43.9219 37.5 43.0625 37.5C42.2031 37.5 41.5 36.7969 41.5 35.9375V14.0625ZM29 14.0625V35.9375C29 36.7969 28.2969 37.5 27.4375 37.5C26.5781 37.5 25.875 36.7969 25.875 35.9375V14.0625C25.875 13.2031 26.5781 12.5 27.4375 12.5C28.2969 12.5 29 13.2031 29 14.0625ZM33.6875 14.0625C33.6875 13.2031 34.3906 12.5 35.25 12.5C36.1094 12.5 36.8125 13.2031 36.8125 14.0625V35.9375C36.8125 36.7969 36.1094 37.5 35.25 37.5C34.3906 37.5 33.6875 36.7969 33.6875 35.9375V14.0625ZM54 4.6875C54 3.82422 53.2969 3.125 52.4375 3.125H43.0625C42.2031 3.125 41.5 2.42578 41.5 1.5625C41.5 0.699609 42.2031 0 43.0625 0H52.4375C55.0254 0 57.125 2.09863 57.125 4.6875V14.0625C57.125 14.9219 56.4219 15.625 55.5625 15.625C54.7031 15.625 54 14.9219 54 14.0625V4.6875ZM14.9375 46.875C15.7969 46.875 16.5 47.5781 16.5 48.4375C16.5 49.2969 15.7969 50 14.9375 50H5.5625C2.97363 50 0.875 47.9004 0.875 45.3125V35.9375C0.875 35.0781 1.57461 34.375 2.4375 34.375C3.30078 34.375 4 35.0781 4 35.9375V45.3125C4 46.1719 4.69922 46.875 5.5625 46.875H14.9375ZM54 35.9375C54 35.0781 54.7031 34.375 55.5625 34.375C56.4219 34.375 57.125 35.0781 57.125 35.9375V45.3125C57.125 47.9004 55.0254 50 52.4375 50H43.0625C42.2031 50 41.5 49.2969 41.5 48.4375C41.5 47.5781 42.2031 46.875 43.0625 46.875H52.4375C53.2969 46.875 54 46.1719 54 45.3125V35.9375Z" fill="#272E35"/>
            </svg>
        )
    }

    const SwapIcon = () => {

        return (
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M42.3125 0.125C41.4531 0.125 40.75 0.824219 40.75 1.6875V14.3145C37.6445 6.73828 30.2617 1.6875 22 1.6875C12.0391 1.6875 3.61133 8.80762 1.9707 18.6113C1.82617 19.4707 2.40039 20.2715 3.25195 20.418C3.33887 20.4277 3.42578 20.4375 3.51074 20.4375C4.25996 20.4375 4.92188 19.8974 5.05078 19.1348C6.44238 10.8379 13.5723 4.8125 22 4.8125C29.0791 4.8125 35.4082 9.19531 37.9766 15.75H26.6875C25.8281 15.75 25.125 16.4531 25.125 17.3125C25.125 18.1719 25.8281 18.875 26.6875 18.875H42.3125C43.1719 18.875 43.875 18.1719 43.875 17.3125V1.6875C43.875 0.824219 43.1719 0.125 42.3125 0.125ZM40.6621 23.582C39.8061 23.4295 39.0049 24.0123 38.8633 24.8633C37.5566 33.1621 30.4277 39.1875 21.9121 39.1875C14.833 39.1875 8.50391 34.8047 5.93555 28.25H17.3125C18.1719 28.25 18.875 27.5469 18.875 26.6875C18.875 25.8281 18.1719 25.125 17.3125 25.125H1.6875C0.824219 25.125 0.125 25.8281 0.125 26.6875V42.3125C0.125 43.1719 0.824219 43.875 1.6875 43.875C2.55078 43.875 3.25 43.1719 3.25 42.3125V29.6855C6.35938 37.2637 13.7383 42.3125 22 42.3125C31.873 42.3125 40.3887 35.1924 42.0293 25.3887C42.1758 24.5293 41.5996 23.7285 40.6621 23.582Z" fill="#272E35"/>
            </svg>
        )
    }

    const MailVisaIcon = () => {
        return(
            <svg width="58" height="44" viewBox="0 0 58 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M46.7832 19.5879C46.7832 19.5879 47.5254 23.2207 47.6914 23.9824H44.4297C44.752 23.1133 45.9922 19.7344 45.9922 19.7344C45.9727 19.7637 46.3145 18.8457 46.5098 18.2793L46.7832 19.5879ZM57.125 4.8125V39.1875C57.125 41.7754 55.0254 43.875 52.4375 43.875H5.5625C2.97461 43.875 0.875 41.7754 0.875 39.1875V4.8125C0.875 2.22461 2.97461 0.125 5.5625 0.125H52.4375C55.0254 0.125 57.125 2.22461 57.125 4.8125ZM15.7676 29.3438L21.9395 14.1875H17.7891L13.9512 24.5391L13.5313 22.4395L12.1641 15.4668C11.9395 14.5 11.2461 14.2266 10.3867 14.1875H4.06836L4 14.4902C5.54297 14.8809 6.91992 15.4473 8.12109 16.1602L11.6172 29.3438H15.7676ZM24.9863 29.3633L27.4473 14.1875H23.5215L21.0703 29.3633H24.9863ZM38.6484 24.4023C38.668 22.6738 37.6133 21.3555 35.3574 20.2715C33.9805 19.5781 33.1406 19.1094 33.1406 18.3965C33.1602 17.752 33.8535 17.0879 35.3965 17.0879C36.6758 17.0586 37.6133 17.3613 38.3164 17.6641L38.668 17.8301L39.2051 14.5488C38.4336 14.2461 37.2031 13.9043 35.6895 13.9043C31.8125 13.9043 29.0879 15.9746 29.0684 18.9238C29.0391 21.1016 31.0215 22.3125 32.5059 23.0449C34.0195 23.7871 34.5371 24.2754 34.5371 24.9297C34.5176 25.9453 33.3066 26.4141 32.1836 26.4141C30.6211 26.4141 29.7812 26.1699 28.502 25.6035L27.9844 25.3594L27.4375 28.7676C28.3555 29.1875 30.0547 29.5586 31.8125 29.5781C35.9336 29.5879 38.6191 27.5469 38.6484 24.4023ZM52.4375 29.3633L49.2734 14.1875H46.2363C45.2988 14.1875 44.5859 14.4609 44.1855 15.4473L38.3555 29.3633H42.4766C42.4766 29.3633 43.1504 27.4883 43.2969 27.0879H48.3359C48.4531 27.625 48.8047 29.3633 48.8047 29.3633H52.4375Z" fill="#272E35"/>
            </svg>
        )
    }

    const ReGiftIcon = () => {
        return (
            <svg width="50" height="44" viewBox="0 0 50 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.1875 40.75H7.8125C5.22754 40.75 3.125 38.6504 3.125 36.0625V7.9375C3.125 5.35254 5.22754 3.25 7.8125 3.25H17.1875C18.0469 3.25 18.75 2.55078 18.75 1.6875C18.75 0.824219 18.0469 0.125 17.1875 0.125H7.8125C3.50391 0.125 0 3.62891 0 7.9375V36.0625C0 40.3691 3.50391 43.875 7.8125 43.875H17.1875C18.0469 43.875 18.75 43.1719 18.75 42.3125C18.75 41.4531 18.0469 40.75 17.1875 40.75ZM49.082 19.793L36.582 7.29297C35.6879 6.39883 34.3447 6.12988 33.1758 6.61543C32.0117 7.09766 31.25 8.24023 31.25 9.5L31.259 15.6621L17.1875 15.75C14.5996 15.75 12.5 17.8496 12.5 20.4375V23.5625C12.5 26.1504 14.5996 28.25 17.1875 28.25L31.2598 28.2499L31.25 34.5C31.25 35.7637 32.0114 36.9043 33.1787 37.3867C34.3477 37.872 35.6904 37.6034 36.585 36.7092L49.085 24.2092C49.6973 23.6016 50 22.8008 50 22C50 21.1992 49.6973 20.3984 49.082 19.793ZM34.375 34.5V25.125H17.1875C16.3281 25.125 15.625 24.4219 15.625 23.5625V20.4375C15.625 19.5781 16.3281 18.875 17.1875 18.875H34.375L34.3746 9.5L46.8746 22L34.375 34.5Z" fill="#272E35"/>
            </svg>

        )
    }

    const determineCardTypeText = (visa, mc, amex) => {
        return (
            amex && visa && mc ? ' a Visa, Mastercard or Amex' :
                visa && mc ? ' a Visa or Mastercard' :
                    visa && amex ? ' a Visa or Amex' :
                        amex && mc ? ' a Mastercard or Amex' :
                            amex ? ' an Amex' :
                                visa ? ' a Visa' :
                                    mc ? ' a Mastercard'
                                        : ''
        )
    }

    const renderRedemptionOptions = (content) => {
        const amex = content?.merchant?.amex_enabled;
        const visa = content?.merchant?.visa_enabled;
        const mc = content?.merchant?.mastercard_enabled;
        return(
            <Grid container justifyContent='space-evenly' spacing={1}>
                {
                    amex || visa || mc ?
                    <Grid item className={classes.gridItem}>
                        <div className={classes.gridItemIcon}><CardIcon /></div>
                        <span className={classes.gridItemTitle}>
                            Activate to {determineCardTypeText(visa,mc,amex)}
                        </span>
                    </Grid> :
                        <></>
                }
                {
                    content?.merchant?.e_gift_exchange_enabled ?
                        <Grid item className={classes.gridItem}>
                            <div className={classes.gridItemIcon}><BarCodeIcon /></div>
                            <span className={classes.gridItemTitle}>Use as an eGift


                                {content?.egift_options?.type === 'range' && (
                                    <>
                                        <br />
                                        (min/max ${content?.egift_options?.denom?.min/100}/${content?.egift_options?.denom?.max/100})
                                    </>
                                )}
                                {content?.egift_options?.type === 'fixed' && (
                                    <>
                                        <br />
                                        (values ${content?.egift_options?.denom?.map(x => x/100)?.join(', $')})
                                    </>
                                )}

                            </span>
                        </Grid> : <></>                        
                }
                <Grid item className={classes.gridItem}>
                    <div className={classes.gridItemIcon}><SwapIcon /></div>
                    <span className={classes.gridItemTitle}>Swap for another merchant</span>
                    </Grid>
                <Grid item className={classes.gridItem}>
                    <div className={classes.gridItemIcon}><MailVisaIcon /></div>
                    <span className={classes.gridItemTitle}>Get a plastic Visa gift card in the mail</span>
                </Grid>
                <Grid item className={classes.gridItem}>
                <div className={classes.gridItemIcon}><ReGiftIcon /></div>
                    <span className={classes.gridItemTitle}>Pay it forward and ReGift</span>                    
                </Grid>
                
        </Grid>
        )
    }
    return (
        <>
            <Grid container justifyContent='center' className={classes.container}>
                <Typography  
                    style={{
                        marginBottom: theme.spacing(2)
                    }} 
                    variant={'h6'}>
                        <div className={classes.typography}>
                            <span style={{marginRight:'5px'}}>Here are the ways your recipient can use their <span dangerouslySetInnerHTML={{__html:content?.merchant?.name}}/> GiftYa</span>
                            <Link
                                style={{
                                    display:'inline-block',
                                    verticalAlign:'middle',
                                    color:theme.palette.secondary.main, 
                                    marginTop:'6px'
                                }}
                                href={'https://stonly.com/sl/en/169807e4-9ce6-471c-be3f-c93c85588e4e/Steps/1386169'}
                                aria-label="help"
                                target={'_blank'}
                            >
                                <HelpOutlineIcon/>
                            </Link>
                        </div>
                </Typography>
                {renderRedemptionOptions(content)} 
            </Grid>         
        </>
    )

     
}

export default WaysToReceive; 